import { secrets } from './environment.secrets';

export const environment = {
  production: false,
  apiBaseUrl: 'https://sandbox.cmsalud.ec:3002',
  systemLegacyUrl: 'https://sistema.cmsalud.ec',
  enviosUrl: 'https://cron-jobs.cmsalud.ec',
  senderApiToken: secrets.senderApiToken,
};
